import Rollbar from 'rollbar'

let env
if (window.location.href.includes('localhost')) {
  env = 'development'
} else if (window.location.href.includes('staging')) {
  env = 'staging'
} else {
  env = 'production'
}

export const rollbar = new Rollbar({
  accessToken: env === 'production'
    ? '9f3056a6c20644bfbda3d83ea81367f7'
    : '5752999fa952442182740452cec87854',
  captureUncaught: true,
  autoInstrument: true,
  payload: {
    environment: env,
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true
      }
    }
  }
})
